<template>
  <div class="flex items-center gap-1 py-[20px]">
    <span class="v3-body-semibold-600-line-height-auto dropdown-title text-gray-500">Language:</span>
    <Dropdown
      v-model="selectedLanguage"
      :options="languages"
      :pt="{
        root: {
          style: {
            border: 'none',
            boxShadow: 'none',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '175%',
            color: '#6C757D',
          },
          class: 'bg-gray-100 outline-none title'
        },
        input: {
          class: 'title px-0',
          style: {
            color: '#6C757D',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '175%',
          }
        },
        trigger: {
          class: 'w-4 ml-1'
        }
      }"
      option-label="label"
      class="md:w-22"
      @change="emit('change', $event.value.code)"
    >
      <template #dropdownicon>
        <Icon
          :width="24"
          :height="24"
          class="title"
          name="caret-down-filled"
        />
      </template>
    </Dropdown>
  </div>
</template>

<script lang="ts" setup>
import Dropdown from 'primevue/dropdown';
import { onBeforeMount, ref } from 'vue';

import Icon from '@/common/components/atoms/Icon';

interface Props {
  value?: string
}

const props = withDefaults(defineProps<Props>(), {
  value: 'en',
});

const emit = defineEmits<{
  change: [ value: string ],
}>();

const languages = ref([
  {
    label: 'English (EN)',
    code: 'en',
  },
  {
    label: 'Français (FR)',
    code: 'fr',
  },
  {
    label: 'Українська (UA)',
    code: 'ua',
  },
  {
    label: 'Türkçe (TR)',
    code: 'tr',
  },
  {
    label: 'Deutsch (DE)',
    code: 'de',
  },
  {
    label: 'Spanish (ES)',
    code: 'es',
  },
  {
    label: 'Italian (IT)',
    code: 'it',
  },
]);

const selectedLanguage = ref(null);

onBeforeMount(() => {
  selectedLanguage.value = languages.value.find(
    (language) => language.code === props.value,
  );
});
</script>

<style scoped>
.dropdown-title {
  color: var(--v3-global-textsecondarycolor, #6C757D);
}
</style>
